import { Injectable, signal } from '@angular/core';
import { type NavigationSection } from 'sms-dashboard';

@Injectable({ providedIn: 'root' })
export class SafetyStateService {
    readonly selectedSection = signal<NavigationSection>('risk-register');

    setSection(section: NavigationSection): void {
        this.selectedSection.set(section);
    }
}
